import { useEffect } from 'react';
import createClient from '../api';

import { useAppContext } from '../contexts/AppContext';

const client = createClient({});

export default () => {
  const {
    setData,
  } = useAppContext();

  useEffect(() => {
    client.getCinematics().then(setData);
  }, []);

  return null;
};
